module.exports = __webpack_public_path__ + "static/img/EbonyMarinoff.1e0a4eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/EbonyMarinoff.jpg
// module id = ED1C
// module chunks = 0